<div class="flex flex-column">
  <div class="mb-2 align-self-stretch">
    <p-tree #PGTREE1 [value]="groupTree"
            filter="showSearch"
            filterPlaceholder="Поиск по имени группы"
            [loading]="loading"
            selectionMode="single"
            [(selection)]="selectedGroupNode"
            (onNodeSelect)="onGroupSelection($event)"
            scrollHeight="50vh"
            styleClass="align-self-stretch">

    </p-tree>
  </div>
  <div class="mr-2 align-self-end" style="height: 3rem">
  </div>
</div>
